import { PointerStyled } from './styles'

export const TooltipPointer = () => <PointerStyled />
